import { fromBlob } from 'file-type/browser';

// prettier-ignore
const supportedImageFormats = [ 'apng', 'bmp', 'gif', '.ico', 'cur', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'tif', 'tiff', 'webp'];
const supportedVideoFormats = ['mp4', 'ogv', 'ogx', 'webm', 'mov'];
const supportedAudioFormats = ['wav', 'mp3', 'ogg', 'mp4', 'aac', 'aacp', 'flac'];
const supportedTextFormats = ['md', 'txt', 'html', 'rtf'];
const supportedOfficeFormats = ['docx', 'doc', 'pptx', 'ppt', 'xlsx', 'xls'];

const supportedOfficeTypes = {
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
  'application/vnd.ms-excel': 'xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
};

export const getFileType = async (file: File | Blob) => {
  const result: {
    extension: string;
    mimeType: string;
    supported: boolean;
    type: null | string;
  } = {
    extension: '',
    mimeType: '',
    supported: false,
    type: null,
  };
  const fileType = await fromBlob(file);
  if (file.type === 'application/pdf') {
    result.extension = 'pdf';
    result.mimeType = file.type;
    result.type = 'pdf';
  } else if (fileType) {
    result.extension = fileType.ext;
    result.mimeType = fileType.mime;
  } else if (Object.keys(supportedOfficeTypes).includes(file.type)) {
    result.extension = (supportedOfficeTypes as { [key: string]: string })[file.type];
    result.type = 'office';
  } else {
    result.mimeType = file.type;
    if (file.type === 'image/svg+xml') {
      result.extension = 'svg';
    } else {
      switch (file.type) {
        case 'text/markdown':
          result.extension = 'md';
          result.type = 'text';
          break;
        case 'application/rtf':
          result.extension = 'rtf';
          result.type = 'text';
          break;
        case 'text/html':
          result.extension = 'html';
          result.type = 'text';
          break;
        case 'text/plain':
          result.extension = 'txt';
          result.type = 'text';
          break;
        default:
          break;
      }
    }
  }

  if (result.extension) {
    if (supportedImageFormats.includes(result.extension)) {
      result.supported = true;
      result.type = 'image';
    } else if (supportedVideoFormats.includes(result.extension)) {
      result.supported = true;
      result.type = 'video';
    } else if (supportedAudioFormats.includes(result.extension)) {
      result.supported = true;
      result.type = 'audio';
    } else if (supportedTextFormats.includes(result.extension)) {
      result.supported = true;
      result.type = 'text';
    } else if (result.extension === 'pdf') {
      result.supported = true;
      result.type = 'pdf';
    } else if (supportedOfficeFormats.includes(result.extension)) {
      result.supported = true;
      result.type = 'office';
    }
  }

  return result;
};
